export const dollarUSLocale = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});